export type HocWrapper<P> = React.ComponentClass<P> | React.SFC<P>;
